import { deepMerge } from './utils'

import english from '../locales/en.json'
import french from '../locales/fr.json'
import spanish from '../locales/es.json'
import german from '../locales/de.json'

const locales = {
	en: english,
	fr: french,
	es: spanish,
	de: german,
}

export default {
	computed: {
		getCurrentLocale() {
			return this.$i18n.locale
		},
	},
	watch: {
		getCurrentLocale() {
			this.updateLocaleMessage()
		},
	},
	methods: {
		updateLocaleMessage() {
			const currentLocale = this.getCurrentLocale

			let localeUse = 'en'
			if (Object.keys(locales).includes(currentLocale)) {
				localeUse = currentLocale
			}

			const combinedLocales = deepMerge(this.$i18n.getLocaleMessage(currentLocale), locales[localeUse])
			this.$i18n.setLocaleMessage(currentLocale, combinedLocales)
		},
	},
	mounted() {
		this.updateLocaleMessage()
	},
}
